<template>
  <div class="app-container">
      <div class="table__page">
        <el-row style="margin-top: 10px;margin-bottom: 20px">
          <el-col :span="6">
            <label style="font-size: 18px">积分清除规则</label>
          </el-col>
        </el-row>
        <hr style="color: #8b8b8b">
        <el-row style="margin-top: 25px">
          <wt-detail-form-section ref="formSection" :detail-form-data.sync="detailFormData" :detail-form.sync="detailForm">
            <template slot="notifyType">
              <el-radio-group v-model="detailFormData.notifyType" :disabled="detailForm.elements[1].disabled">
                  <el-radio :label="1">一个月</el-radio>
                  <el-radio :label="2">两个月</el-radio>
                  <el-radio :label="3">三个月</el-radio>
                  <el-radio :label="4">六个月</el-radio>
              </el-radio-group>
            </template>
          </wt-detail-form-section>
        </el-row>
        <el-row style="margin-top: 25px; text-align: center;">
            <el-button type="default" size="small" v-if="isEditFlag" @click="toCancel">取消</el-button>
            <wt-auth :hasAnyPremission="'MODULE_INTEGRALCLEARRULES:EDIT'" class="search-form-btn">
              <el-button type="primary" size="small" v-if="!isEditFlag" @click="toEdit">编辑</el-button>
            </wt-auth>
            <wt-auth :hasAnyPremission="'MODULE_INTEGRALCLEARRULES:CLEAR'" class="search-form-btn">
              <el-button type="danger" size="small" v-if="!isEditFlag" @click="toClear">清除</el-button>
            </wt-auth>
            <el-button type="primary" size="small" v-if="isEditFlag" @click="saveBtn">保存</el-button>
        </el-row>
      </div>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'integralClearRules',
  data() {
    return {
      isEditFlag: false,
      detailForm: {
        title: '',
        className: 'wt-section-long-content',
        elements: [
          { name: '清除时间', key: 'cleanTime', type: 'date', disabled: true, required: false },
          { name: '通知用户时间', key: 'notifyType', type: 'custom', disabled: true, required: false }]
      },
      detailFormData: {}
    }
  },
  mounted() {
    this.integralClean()
  },
  methods: {
    toEdit() {
      for (const item of this.detailForm.elements) {
        item.disabled = false
        item.required = true
      }
      this.isEditFlag = true
    },
    toCancel() {
      for (const item of this.detailForm.elements) {
        item.disabled = true
        item.required = false
      }
      this.isEditFlag = false
      this.integralClean()
    },
    toClear() {
      this.$wtUtil.deleteConfirm(this, `确认清除吗？`).then(() => {
        request.post('/modules/integralRules/integralCleanRemove').then(res => {
          if (!res) return false
          this.$message({ message: '操作成功', type: 'success' })
          this.toCancel()
        })
      })
    },
    saveBtn() {
      this.$wtUtil.deleteConfirm(this, `确认提交此次更改吗？`).then(() => {
        request.post('/modules/integralRules/integralCleanAdd', this.detailFormData).then(res => {
          if (!res) return false
          this.$message({ message: '操作成功', type: 'success' })
          this.toCancel()
        })
      })
    },
    integralClean() {
      request.post('/modules/integralRules/integralClean').then(res => {
        if (res.data) {
          this.detailFormData = res.data
        } else {
          this.detailFormData = {
            cleanTime: '',
            notifyType: ''
          }
        }
      })
    }
  }
}
</script>

<style>
</style>
